@if (showLoader) {
    <app-loader [isOverlay]="false" size="small" />
} @else if (cards.length) {
    @for (card of cards; track card.cardId) {
        @if (dashboardsService.isJobsBilling()) {
            <wk-card-jobs-billing [cardData]="card" [statusIds]="card.statusIds" [format]="'column'"></wk-card-jobs-billing>
        } @else {
            <wk-card-t1 [cardData]="card" [statusIds]="card.statusIds" [format]="'column'" [hideArrows]="true"></wk-card-t1>
        }
    }
} @else {
    <div class="wk-search-result__empty">{{ "SearchBar.EmptySearchResult" | translate }}</div>
}
